/**
 * @file 検索条件保存
 *
 */
'use strict'
import Common from '../../Utils/Common'
import ApplyClass from '../../Utils/ApplyClass'
import BtnDeleteFilter from './BtnDeleteFilter'

/**
 * @classname SaveFilter
 * @classdesc 検索条件保存
 */
export default class SaveFilter {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-input-filter-name')
	 */
	constructor($e, controller) {
		console.log('SaveFilter.constructor')
		this._$e = $e
		this._controller = controller
		this._errorNames = []
		this._enteredItemsCount = 0
		this._reachedUpperLimit = false
		this._validity = true
		this._searchType = $('#search_type').val()
		this._currentSearchQuery = ''
		this._filterName = ''
		this._FilterNameInputModal = new bootstrap.Modal(document.getElementById('modal-input-filter-name'))
		this._completeFilterSaveModal = document.getElementById('modal-complete-filter-save')
		this._CompleteFilterSaveModal = new bootstrap.Modal(this._completeFilterSaveModal)
		this._savedFiltersModal = document.getElementById('modal-saved-filters')
		this._SavedFiltersModal = new bootstrap.Modal(this._savedFiltersModal)
		this._FiltersCountReachedUpperLimitModal = new bootstrap.Modal(document.getElementById('modal-filters-count-reached-upper-limit'))
		this._$btnSaveFilter = $('.btn-save-filter')
		this._$inputFilterName = $('#modal-input-filter-name').find('input')
		this._$inputFilterNameErrorTip = $('#modal-input-filter-name').find('.error-tip')
		this._$e.on('click', () => this.onBtnInputFilterNameClick())
		this._$btnSaveFilter.on('click', () => this.onBtnSaveFilterClick())
		this._completeFilterSaveModal.addEventListener('hidden.bs.modal', () => this.getSavedFilters())
		this._controller.on('saveFilterComplete', () => this.onSaveFilterComplete())
	}


	/**
	 * クリックコールバック
	 *
	 * @memberof SaveFilter
	 */
	onBtnInputFilterNameClick() {
		console.log('SaveFilter.onBtnInputFilterNameClick')
		this.checkSavedFiltersCount()
		if (this._reachedUpperLimit) return
		this._currentSearchQuery = this.getCurrentSearchQuery()
		this.checkError()
		if (this._validity) this._FilterNameInputModal.show()
	}


	/**
	 * 保存済検索条件数を確認
	 *
	 * @memberof SaveFilter
	 */
	checkSavedFiltersCount() {
		console.log('SaveFilter.checkSavedFiltersCount')
		this._reachedUpperLimit = false
		if ($(this._savedFiltersModal).find('.list-saved-filters .list-item').length == 20) {
			this._reachedUpperLimit = true
			this._FiltersCountReachedUpperLimitModal.show()
		}
	}

	/**
	 * 現在の検索条件を取得
	 *
	 * @memberof SaveFilter
	 * @return {string} query - 検索GETパラメーター
	 */
	getCurrentSearchQuery() {
		console.log('SaveFilter.getCurrentSearchQuery')
		let prefix = '?'
		let query = ''
		this._errorNames = []
		this._enteredItemsCount = 0
		$('[data-search-item]').each((idx, e) => {
			const $e = $(e)
			const name = $e.attr('name')
			switch ($e.attr('data-search-type')) {
				case 'radio': {
					const checked = $(`input[type=radio][name=${name}]:checked`)
					const value = checked.val()
					if (value !== 'all') {
						this._enteredItemsCount++
						query += `${prefix}${$e.attr('data-search-item')}=${value}`
						prefix = '&'
					}
				}
				break
				case 'checkbox': {
					if ($e.prop('checked')) {
						const value = $e.val()
						this._enteredItemsCount++
						query += `${prefix}${$e.attr('data-search-item')}=${value}`
						prefix = '&'
					}
				}
				break
				case 'array_base': {
					let value = $(`[data-search-item=${name}`).map((idx, e) => {
						const $e = $(e)
						if ($e.prop('checked')) return $e.val()
					}).get().join('|')
					if (value.length > 0) {
						this._enteredItemsCount++
						query += `${prefix}${name}=${value}`
						prefix = '&'
					}
				}
				break
				case 'multiple': {
					console.log($e.attr('id'))
					let value = $e.find('option:selected').map((idx, e) => {
						return $(e).val()
					}).get().join('|')
					if (value.length > 0) {
						this._enteredItemsCount++
						query += `${prefix}${name}=${value}`
						prefix = '&'
					}
				}
				break
				default: {
					if ($e.is(':invalid')) {
						console.log($e.attr('data-search-item') + ': ' + $e.is(':valid'))
						if ($e.prop('required')) this._errorNames.push($e.data('search-item-name'))
					}
					const value = encodeURIComponent($e.val())
					if (value !== '') {
						this._enteredItemsCount++
						query += `${prefix}${$e.attr('data-search-item')}=${value}`
						prefix = '&'
					}
				}
			}
		})
		return query
	}


	/**
	 * エラーチェック
	 *
	 * @memberof SaveFilter
	 */
	checkError() {
		console.log('SaveFilter.checkError')
		this._validity = true
		if(!!this._errorNames.length) {
			this._validity = false
			let message = ''
			errorNames.forEach((errorName, idx) => idx == 0 ? message += errorName : message += `、${errorName}`)
			Common.showErrorModal(`${message}は必須です。`)
		} else if (this._enteredItemsCount == 0) {
			this._validity = false
			Common.showErrorModal(`検索条件を入力してください。`)
		}
	}


	/**
	 * 「保存する」ボタンクリックのコールバック
	 *
	 * @memberof SaveFilter
	 */
	onBtnSaveFilterClick() {
		console.log('SaveFilter.onBtnSaveFilterClick')
		this.validateFilterName()
		if (this._validity) {
			this._$inputFilterName.val('')
			this._FilterNameInputModal.hide()
			this.saveFilter()
		}
	}


	/**
	 * 検索条件保存名入力チェック
	 *
	 * @memberof SaveFilter
	 */
	validateFilterName() {
		console.log('SaveFilter.validateFilterName')
		this._validity = true
		this._filterName = ''
		if (this._$inputFilterName.val() == '') {
			this._validity = false
			this._$inputFilterNameErrorTip
				.addClass('show')
				.find('.error-tip-inner')
				.html('<p>この項目は必須です。</p>')
		} else {
			this._filterName = this._$inputFilterName.val()
			this._$inputFilterNameErrorTip
				.removeClass('show')
				.find('.error-tip-inner')
				.html('')
		}
	}


	/**
	 * 検索条件保存
	 *
	 * @memberof SaveFilter
	 */
	saveFilter() {
		console.log('SaveFilter.saveFilter')
		this._controller.saveFilter(this._searchType, this._filterName, this._currentSearchQuery)
	}


	/**
	 * 検索条件保存完了時のコールバック
	 *
	 * @memberof SaveFilter
	 */
	onSaveFilterComplete() {
		console.log('SaveFilter.onSaveFilterComplete')
		this._CompleteFilterSaveModal.show()
	}


	/**
	 * 保存済検索条件リストの取得
	 *
	 * @memberof SaveFilter
	 */
	getSavedFilters() {
		console.log('SaveFilter.getSavedFilters')
		this._controller.getSavedFilters(this._searchType)
	}
}
